module.exports = __webpack_public_path__ + "img/choose-account.5dd19a56.jpg";